import { OfferCard } from '@libs/creditkit';
import { OfferProps } from '@hub/types';
import { useUser } from '@common/hooks/useUser';

export const MainOfferCard = ({ offer, index, location, smallCard = false }: OfferProps) => {
  const user = useUser();

  return <OfferCard offer={offer} index={index} location={location} user={user} smallCard={smallCard} />;
};
